<template>
  <div class="site-view">
    <Header />
  <Modal v-if="modalOpen" :Selected="strategies.selected" />
    <!--Way forward section-->
    <!-- <section class="page-section banner page2-hero">
      
      <div class="container">
        <div class="row">
          <div class="col m12 l6">
            <div class="article">
              <h1>The Way Forward</h1>
              <hr class="header-underline main" />
              <p  class="right-border">Doing nothing is not an option</p>
              

<p>Continuing the growth in Huntingdonshire makes it urgent to develop a better transport network for people who live and travel in 
the area. </p>
<p>A network that respects our heritage and environment but can sustain more growth. It needs to factor in health and wellbeing, active travel, carbon-reduction, and the needs of those with homes or businesses. </p>
<p>So, the A141 Improvement Scheme to tackle the road’s current problems is going to happen – but the actual option has yet to be decided. That is where your insights, views and comments come in. The Combined Authority and partners will use the results to help decide the best way forward for the A141 Improvement Scheme. </p>
  
            </div>
          </div>
          <div class="col m12 l5"></div>
        </div>
      </div>
    </section> -->
    <!--Strategic option section-->
    <section class="page-section nav-section">
     
      <div class="container">
        <div class="article-nav">
          <h1>Our Route Considerations</h1>
          <p>Please take a look at all our different route considerations. If you have any feedback please view our feedback page and you can have input into the ongoing changes!</p>
          <hr class="header-underline" />
          <div class="navs">
            <div
              v-for="(strategy, index) in strategies.strats"
              :key="`strategies_navs_${index}`"
            >
              <h2
                v-if="index !== strategies.selected"
                @click="() => selectStrategy(index)"
              >
                {{ strategy.shortHeader }}
              </h2>
              <h2 v-if="index === strategies.selected" class="active">
                {{ strategy.shortHeader }}
              </h2>
            </div>
          </div>
          <div class="selects">
            <form>
              <select v-model="strategies.selected">
                <option
                  v-for="(strategy, index) in strategies.strats"
                  :key="`strategies_option_${index}`"
                  :value="index"
                >
                  {{ strategy.header }}
                </option>
              </select>
            </form>
          </div>
          <hr style="margin-bottom: 4rem" />

          <div class="nav-content">
            <div class="row">
              <div class="col s12 l6">
                <div class="nav-text">
                  <h2>{{ strategies.strats[strategies.selected].header }}</h2>
                  <ul>
                    <li
                      v-for="(text, index) in strategies.strats[
                        strategies.selected
                      ].text"
                      :key="`strategies_text_${index}`"
                    >
                      {{ text }}
                      <ul
                        v-if="
                          strategies.strats[strategies.selected].subtext &&
                          index === 0
                        "
                      >
                        <li
                          v-for="(sub, j) in strategies.strats[
                            strategies.selected
                          ].subtext"
                          :key="`tab_${index}_subtext_${j}`"
                        >
                          {{ sub }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div>
                    <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].additionalText"
                      :key="`strategies_additionaltext_${index}`"
                    >
                      {{ p }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col s12 l6">
                <div
                  class="img"
                  :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/images/a141/way_forward/updated/option_' +
                        (strategies.selected + 1) +
                        '.png') +
                      ')',
                  }"
                >
                  <div class="modalOpenButton" @click="openModal">
                    <i class="fas fa-expand"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- new start -->
            <div class="row">
              <div class="col s12 l6">
                <div
                  class="img"
                  :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/images/a141/way_forward/updated/option_' +
                        (strategies.selected + 1) +
                        '.png') +
                      ')',
                  }"
                >
                  <div class="modalOpenButton" @click="openModal">
                    <i class="fas fa-expand"></i>
                  </div>
                </div>
              </div>
              <div class="col s12 l6">
                <div class="nav-text">
                  <h2>{{ strategies.strats[strategies.selected].headerMore }}</h2>
                  <ul>
                    <li
                      v-for="(text, index) in strategies.strats[
                        strategies.selected
                      ].textMore"
                      :key="`strategies_text_${index}`"
                    >
                      {{ text }}
                      <ul
                        v-if="
                          strategies.strats[strategies.selected].subtext &&
                          index === 0
                        "
                      >
                        <li
                          v-for="(sub, j) in strategies.strats[
                            strategies.selected
                          ].subtext"
                          :key="`tab_${index}_subtext_${j}`"
                        >
                          {{ sub }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div>
                    <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].additionalTextMore"
                      :key="`strategies_additionaltext_${index}`"
                    >
                      {{ p }}
                    </p>
                  </div>
                </div>
              </div>
              
            </div>



            <!-- new end-->
          </div>
        </div>
      </div>
    </section>
    <!--Policy section-->
    <!-- <section class="page-section darken">
      <div class="container">
        <h1>Wider Policy Objectives</h1>
        <hr class="header-underline" />
        <div class="card-space boxes">
          <div
            class="card"
            v-for="(policy, index) in policies"
            :key="`policy_boxes_${index}`"
          >
            <div
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/images/a141/way_forward/updated_icons/wayf/cardBox' +
                    (index + 1) +
                    '.png') +
                  ')',
              }"
            ></div>
            <div>
              <p>{{ policy }}</p>
            </div>
          </div>
        </div>
      </div>
    </section> -->

  
<!-- 
    <section class="page-section pinkbg">
      <img
        src="@/assets/images/a141/gif/03-Old-Lady.gif"
        class="right-corner-image"
      />
      <div class="container">
        <div class="row">
          <div class="col m12 l7">
            <div class="article dark">
              <h1>The Goals</h1>
              <hr class="header-underline" />
              <p>A141 Improvements aim to;</p>
              <ul>
                <li>
                  Address current congestion and delay on the corridor, reducing
                  journey times and improving reliability
                </li>
                <li>
                  Ensure sufficient highway capacity to accommodate transport
                  demand on the corridor from new growth sites in the region 
                </li>
                <li>
                  Improve connectivity and quality for walking and cycling along
                  and across the corridor by:
                  <ul>
                    <li>
                      Incorporating appropriate provision within the scheme
                    </li>
                    <li>
                      Enabling the existing A141 to better support these modes
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div class="col s5"></div>
        </div>
      </div>
    </section> -->

    <!--Timeline Section-->
    <!--When screen width is medium-large-->
    <section class="page-section" id="timeline-progress-section">
      <div class="container" style="position: relative">
        <h1>A141 Countdown</h1>
        <hr class="header-underline" />

        <div class="timeline">
          <div
            v-for="(date, index) in timeline.time"
            :key="`timeline_date_${index}`"
            class="timeline-point"
            @click="() => selectTimeline(index)"
          >
            <!--Inactive timeline image-->
            <div
              v-if="index !== timeline.selected"
              class="timeline-icon"
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/images/a141/way_forward/timeLineImg.png') +
                  ')',
              }"
            ></div>
            <!--Active timeline image-->
            <div
              v-if="index === timeline.selected"
              class="timeline-icon active"
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/images/a141/way_forward/timeLineImg.png') +
                  ')',
              }"
            ></div>
            <!--Inactive progress points-->
            <div v-if="index > timeline.selected" class="progress-point"></div>
            <!--Passed progress points-->
            <div
              v-if="index < timeline.selected"
              class="progress-point active"
            ></div>
            <!--Active progress points-->
            <div
              v-if="index === timeline.selected"
              class="progress-check active"
            >
              <i class="fas fa-check"></i>
            </div>
            <!--Inactive header-->
            <h2 v-if="index !== timeline.selected">{{ date.header }}</h2>
            <!--Active header-->
            <h2 v-if="index === timeline.selected" class="active">
              {{ date.header }}
            </h2>
          </div>
        </div>
        <div class="timeline-progress">
          <div class="bar"></div>
          <div id="timeline-fill" class="bar fill"></div>
        </div>
        <div class="section-card">
          <h2>
            <i class="fas fa-check"></i>
            {{ timeline.time[timeline.selected].header }}
          </h2>
          <p>
            {{ timeline.time[timeline.selected].text }}
          </p>
        </div>
      </div>
    </section>

    <!--Timeline Section-->
    <!--When screen width is medium-large-->
    <section class="page-section" id="timeline-cards-section">
      <div class="container">
        <h1>A141 Improvement Timeline</h1>
        <hr class="header-underline" />
        <div class="card-space boxes">
          <div
            class="card"
            v-for="(date, index) in timeline.time"
            :key="`timeline_card_${index}`"
          >
            <div
              class="img"
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/images/a141/way_forward/timeLineImg.png') +
                  ')',
              }"
            ></div>
            <div class="timeline-card-text">
              <h2>{{ date.header }}</h2>
              <p>{{ date.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--have your say section-->
    <!-- <section class="page-section survey">
      <div class="container">
        <div class="row">
          <div class="col m12 l7">
            <div class="summary-card">
              <h1>Have Your Say!</h1>
              <hr class="header-underline" />
              <p class="section-blurb">
                This is your A141, your future. Your opinion will shape the
                all-important decision on how and where we should improve the
                A141. Please now consider the options and tell us which you
                prefer.
              </p>
              <button class="link1">Have Your Say!</button>
            </div>
          </div>
          <div class="com m0 l5"></div>
        </div>
      </div>
    </section> -->
   <section class="page-section survey">
      <div class="container">
        <div class="row">
          <div class="col m12 l7">
            <div class="summary-card">
              <h1>Have Your Say!</h1>
              <hr class="header-underline" />
              <p>
                This is your A141, your future. Your opinion will shape the
                all-important decision on how and where we should improve the
                A141. Please now consider the options and tell us which you
                prefer.
              </p>
               <a href="/map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback"><button class="link1">Have Your Say!</button></a>
            </div>
          </div>
          <div class="com m0 l5"></div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Header from "@/components/belfast/Header";
import Footer from "@/components/customPages/components/footer";
import Modal from "@/components/customPages/components/MapModal";
// var $ = require("jquery");
//import fancybox from "jquery-fancybox";

export default {
  name: "schemesPage",
  data() {
    return {
      modalOpen:false,
      policies: [
        "Attract investment and good-earning employment opportunities",
        "Improve access around Huntingdon to/from road and rail networks and to/from London",
        "Extend the success of Greater Cambridge across the region",
        "Improve capacity, reliability and speed for public transport and opportunity for cyclists, walkers, and equestrians",
        "Maintain traffic at or below 2018 levels",
        "Cut vehicle mileage",
        "Intercept or substitute car trips with alternative transport modes",
        "Contribute to the reduction of emissions to ‘net zero’ by 2050, to minimise the impact of transport and travel on climate change",
      ],
      strategies: {
        selected: 0,
        strats: [
          {
            shortHeader: "City Center",
            header: "Full Offline Bypass with no connections",
            text: [
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments.",
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments.",
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments.",
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments.",
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments."
            ],
            headerMore: "Full Offline Bypass with no connections MORE",
            textMore: [
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments.",
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments.",
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments.",
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments.",
              "A new bypass from Spittals Interchange to Sawtry Way roundabout (B1090/A141), with no connections to existing roads or the new developments."
            ],
            additionalTextMore: [""],
          },
          {
            shortHeader: "South Belfast",
            header: "Full Offline Bypass with connections",
            text: [
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ipsum ipsum, sodales in egestas a, lacinia nec velit. Vestibulum dictum nunc efficitur augue porttitor tincidunt. Ut eleifend ante sed sapien pellentesque, nec tristique risus pretium. Pellentesque quis semper purus, sed lobortis dui. Vivamus nunc dui, varius sit amet enim vel, sollicitudin aliquet nisi. ",
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ipsum ipsum, sodales in egestas a, lacinia nec velit. Vestibulum dictum nunc efficitur augue porttitor tincidunt. Ut eleifend ante sed sapien pellentesque, nec tristique risus pretium. Pellentesque quis semper purus, sed lobortis dui. Vivamus nunc dui, varius sit amet enim vel, sollicitudin aliquet nisi.",
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ipsum ipsum, sodales in egestas a, lacinia nec velit. Vestibulum dictum nunc efficitur augue porttitor tincidunt. Ut eleifend ante sed sapien pellentesque, nec tristique risus pretium. Pellentesque quis semper purus, sed lobortis dui. Vivamus nunc dui, varius sit amet enim vel, sollicitudin aliquet nisi."
            ],
            additionalText: [
            "Upgrading / extending the existing Old Houghton Road bridle path.",
              "Dedicated walking and cycling infrastructure from the Ermine Street Business Park to the A1123/A141 junction along the current A141 and from the Ermine Street Business Park to St. Peters Road.",
              "Additional walking and cycling crossing points over the East Coast Main Line.",
              "Public Transport infrastructure along St. Peters Road and opening access at the old Sapley Road crossroads for public transport.",
              "Public transport and active travel connections between new developments and Huntingdon town centre.",
            ],
          },
          {
            shortHeader: "North Belfast",
            header: "Online / Offline Option",
            text: [
              "A new bypass from Spittals Interchange to the Tesco Roundabout.",
              "Widening of the existing A141 from the Tesco Roundabout to the Hartford Roundabout.",
            ],
            additionalText: ["* Clean Air Zone (CAZ) – area where targeted action is taken to improve air quality, in particular by discouraging the most polluting vehicles from entering the zone.",
              "** Environmental Weight Limit – weight limit preventing large vehicles from using inappropriate roads, routes and areas.",
              "*** Workplace Parking Levy (WPL) – a charge on employers for the number of parking places they provide that are regularly used by employees."],
          },
          {
            shortHeader: "Disguarded Route Options",
            header: "Rural Travel Hubs",
            text: [
              "Indicative locations of potential Rural Travel Hubs (RTHs)*.",
              "The arrows represent the areas which each RTH would aim to serve, with specific site locations to be defined.",
              "Implementation would likely require combining with bus priority infrastructure towards Huntingdon.",
            ],
            additionalText: [
              "* Rural Travel Hub (RTH) – small, flexible transport interchanges at key locations, allowing more people to access sustainable transport networks.",
            ],
          },
          
        ],
      },
      timeline: {
        selected: 0,
        time: [
          {
            header: "Spring 2021",
            subheader: "",
            text:
              "We will analyse the engagement responses and undertake additional technical work",
          },
          {
            header: "Autumn 2021",
            subheader: "Header Needed",
            text:
              "Report on the findings within a Business Case and options selected to the Combined Authority Board",
          },
          {
            header: "Winter 2021",
            subheader: "Header Needed",
            text:
              "Commitment for funding to commence the Outline Business Case preliminary design. Further discussions to be held with the  Department for Transport to discuss next stages  ",
          },
          {
            header: "Autumn 2022",
            subheader: "Header Needed",
            text:
              "Outline Business Case completed and commence Full Business Case and Detailed Design   ",
          },
          {
            header: "Indicative",
            subheader: "Header Needed",
            text: "Dependent on conclusions of Autumn 2021 report",
          },
        ],
      },
    };
  },
  components: {
    Header,
    Footer,
    Modal
  },
  methods: {
    selectStrategy(index) {
      this.strategies.selected = index;
    },
    selectTimeline(index) {
      this.timeline.selected = index;

      this.progressUpdate(index);
    },
    progressUpdate(index) {
      let progress = document.getElementById("timeline-fill");
      let points = document.querySelectorAll(".timeline-point");

      progress.style.width = `${((index + 1 - 1) / (5 - 1)) * 100}%`;
    },
    openModal(){
      this.modalOpen=true;
    },
    closeModal(){
      this.modalOpen=false;
    }
  },
  computed: {
    ...mapState(["entities", "entityTypes"]),
    ...mapGetters(["user", "allEntityTypes", "allEntities"]),
    pageData() {
      if (this.$route.params.id != undefined) {
        return this.allEntities.find(
          (item) => item.docId == this.$route.params.id
        );
      } else {
        return this.allEntities.find(
          (item) => item.type == this.$route.params.templateName
        );
      }
    },
  },
  mounted() {
    // $(document).ready(function () {
    //   $(".modal").modal();
    // });
  },
  watch: {
    $route(to, from) {
      this.activeInstance = to.params.root;
    },
  },
};
</script>
<style lang="scss" scoped>
.modalOpenButton { 
 
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 0 5px 4px rgba(29, 50, 92, 0.07);

  i {
    font-size: 25px;
    padding:  6.5px 9.5px;
    color: #4b789c;
  }
}

</style>